import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="footer-section py-12 px-6 md:px-12">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <Link to="/" className="text-2xl text-[#EDEDED]" style={{ fontFamily: "'Playfair Display', serif" }}>
          Breedling
        </Link>
        <nav className="flex items-center gap-6">
          <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/developers" className="footer-link">Developers</Link>
          <a href="mailto:support@breedling.com" className="footer-link">Contact</a>
        </nav>
      </div>
      <div className="mt-8 pt-8 border-t border-white/5 text-center">
        <p className="text-xs text-[#71717A] mb-2">Breedling promotes ethical breeding and compliance with all local laws.</p>
        <p className="text-xs text-[#71717A]">&copy; {new Date().getFullYear()} Breedling&trade;. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
